import { capitalCase } from '../Strings/CapitalCase';

export const slugPartToWords = (slugPart: string) => capitalCase(slugPart.replace(/_/g, ' '));
